var map = {
	"./genealogy.json": [
		93327,
		327
	],
	"./handshake.json": [
		20225,
		55
	],
	"./locations.json": [
		48931,
		931
	],
	"./lock.json": [
		12670,
		670
	],
	"./medicine.json": [
		64821,
		821
	],
	"./regulations.json": [
		94090,
		90
	],
	"./searching.json": [
		41394,
		394
	],
	"./tags.json": [
		71364,
		364
	],
	"./users.json": [
		70702,
		702
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 19955;
module.exports = webpackAsyncContext;